module.exports = __webpack_public_path__ + "img/img-no.bf68ac22.png";